import {
  Form,
  Input,
  Select,
  InputNumber,
  Checkbox,
  Tabs,
  Button,
  message,
  Cascader,
  AutoComplete,
  Tooltip,
  Table, notification,
} from 'antd';
import PageContent from '../../components/PageContent';
import {getCompanyList, getProjectsList} from '../../api/Projects';
import { addReport, getCategories, getlevels } from '../../api/Report';
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import {currentToken, currentUser, setUser} from '../../features/user/userSlice';
import { useNavigate,useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FilesUpload from './components/FilesUpload';
import MarkdownIt from 'markdown-it';
import {MarkdownEditor} from "../../components/MarkdownEditor";
import ReCAPTCHA from "react-google-recaptcha";
import { useLocation } from 'react-router';
import { CustomInputNumber, CustomQuestionCircleOutlined, CustomTooltip } from '../../components/CustomForm';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { CustomTable } from '../../components/Common';
import {getPersonalInfo} from "../../api/User";


const mdParser = new MarkdownIt(/* Markdown-it options */);

const AddReport = () => {
  // 引入多语言Hooks
  const { t } = useTranslation();
  // 定义变量
  const [params] = useSearchParams()
  const [optionData, setOptionData] = useState([]);
  const [optionPagination, setOptionPagination] = useState({ page: 1 });
  const [cascaderOptions, setCascaderOptions] = useState([]);
  const [levels, setLevels] = useState([]);
  const [prevScrolltop, setPrevScrolltop] = useState(0);
  const [others, setOthers] = useState(false);
  const [TextAreaHeight, setTextAreaHeight] = useState(142);
  const [TextAreaHeight2, setTextAreaHeight2] = useState(142);
  const [TextAreaValue, setTextAreaValue] = useState(``);
  const [TextAreaValue2, setTextAreaValue2] = useState('');
  const [name, setName] = useState('');
  const [filesArray, setFilesArray] = useState([]);
  const [_project, setProject] = useState(params.get('project') ?? '');
  const [_projectId, setProjectId] = useState(params.get('project_id') ?? 0);

  const [minPoints, setMinPoints] = useState(0);
  const [maxPoints, setMaxPoints] = useState(0);

  const user = useSelector(currentUser);

  // 获取 redux 中的 token
  const token = useSelector(currentToken);
  // 声明 navigate hooks函数方法
  const navigate = useNavigate();

  const location = useLocation()

  const { Option } = Select;
  const { TabPane } = Tabs;
  // 定义 form 对象
  const [form] = Form.useForm();

  // useEffect

  // 验证是否登录
  useEffect(() => {
    if (!token) {
      message.warning('Please login first');
      navigate('/login?redirect_url='+location.pathname);
    } else {
      return;
    }
  }, [token]);

  // 获取厂商列表 分类数据
  useEffect(() => {
    fetchProjects();
    fetchCategories();
    fetchLevels();
  }, []);

  const accessCheck = async () => {
    if (!user.user.wallet_address || user.user.wallet_address === '') {
      const { code, data } = await getPersonalInfo();
      if (code === '10000') {
        if (!data.hacker.wallet_address) {
          notification.warning({
            key: 'warning',
            description: (
                <span
                    style={{
                      fontSize: '16px',
                    }}
                >
                  Please set your wallet address before submitting your report.
                </span>
            )
          })
          navigate('/user?page=my_info', { state: { wallet_address: true } });
        }
      }
    }
  };

  // 报告详情占位文字
  useEffect(() => {
//     form.setFieldsValue({
//       detail: `## Bug Description
// A clear and concise description of the bug.
//
// ## Impact
//
// ## Risk Breakdown
// Difficulty to Exploit: Easy
// Weakness:
// CVSS2 Score:
//
// ## References
// `,
//     });
    setTextAreaValue(`#### Bug Description
A clear and concise description of the bug.

#### Impact

#### PoC

#### References
`);
    accessCheck()
  }, []);

  // 获取厂商列表
  const fetchProjects = async () => {
    const { data } = await getCompanyList();
    setOptionData([...data, { id: 0, name: 'Other' }]);
  };

  // 厂商分页数据
  const handleScrollToFetch = async (scrollTop) => {
    const { data } = await getProjectsList({
      page: optionPagination.page + 1,
    });
    setOptionPagination({ page: data.current_page });
    setOptionData([...optionData, ...data.list]);
    setPrevScrolltop(scrollTop);
  };

  // 获取分类数据
  const fetchCategories = async () => {
    try {
      const { code, data } = await getCategories();
      if (code === '10000') {
        setCascaderOptions(data);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  // 获取报告等级数据
  const fetchLevels = async () => {
    try {
      const { code, data } = await getlevels();
      if (code === '10000') {
        setLevels(data);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  // 自动填充厂商名字是否为其他
  const handleChange = (value) => {
    if (value === 'Other') {
      setOthers(true);
    } else {
      setOthers(false);
    }
  };

  // 列表滚动
  const handlePopupScroll = (e) => {
    // 192 is the height of the popup
    let scrollTop = e.target.scrollTop;
    if (scrollTop - prevScrolltop >= 96) {
      handleScrollToFetch(scrollTop);
    }
  };

  /**
   *
   * handleTextAreaResize 文本域高度自适应
   * handleOnEnter 文本域回车事件
   * handleTextAreaChange 文本域内容变化事件
   * ... 以此类推一样的
   */

  const handleTextAreaResize = ({ width, height }) => {
    const markDown = document.getElementsByClassName('add-react-markdown')[0];
    if (height) {
      setTextAreaHeight(height < 142 ? 252 : height);
    }
    if (markDown) {
      markDown.style.height = `${TextAreaHeight}px`;
    }
  };

  const handleOnEnter = (e) => {
    if (e.target.clientHeight) {
      setTextAreaHeight(
        e.target.clientHeight < 142 ? 142 : e.target.clientHeight + 24
      );
    }
  };

  const handleTextAreaChange = ({text, html}) => {
    if (e.target.clientHeight) {
      setTimeout(() => {
        setTextAreaHeight(
          e.target.clientHeight < 142 ? 142 : e.target.clientHeight + 2
        );
      }, 0);
    }
    setTextAreaValue(e.target.value);
  };

  const handleTextAreaResize2 = ({ width, height }) => {
    const markDown = document.getElementsByClassName('add-react-markdown-2')[0];
    if (height) {
      setTextAreaHeight2(height < 142 ? 142 : height);
    }
    if (markDown) {
      markDown.style.height = `${TextAreaHeight2}px`;
    }
  };

  const handleOnEnter2 = (e) => {
    if (e.target.clientHeight) {
      setTextAreaHeight2(
        e.target.clientHeight < 142 ? 142 : e.target.clientHeight + 24
      );
    }
  };

  const handleTextAreaChange2 = (e) => {
    if (e.target.clientHeight) {
      setTimeout(() => {
        setTextAreaHeight2(
          e.target.clientHeight < 142 ? 142 : e.target.clientHeight + 2
        );
      }, 0);
    }
    setTextAreaValue2(e.target.value);
  };

  // tabs 切换
  const TabsChange = (e) => {
    // console.log(e);
  };

  // 表单提交
  const handleFormFinsh = (form) => {
    const {...values} = form
    values.is_anonymity = values.is_anonymity ? 1 : 0;
    values.category_id = values.category_ids[0];
    values.level_id = values.level_id[0];
    if (filesArray.length !== 0) {
      values.attachment_ids = filesArray;
    }
    let company_id;
    let current = optionData.find((item) => item.name === values.company_name);

    if (current && current.id !== 0) {
      company_id = current.id;
    } else if (values.company_name === 'Other') {
      company_id = 0;
      values.company_name = values.company_confirm;
    }else if(_projectId !== 0){
      company_id = _projectId;
      values.company_name = _project;
    }

    const new_data = { ...values, company_id, detail: TextAreaValue, solution: TextAreaValue2 };
    uploadReport(new_data);
  };

  const captchaRef = useRef(null);

  // 表单上传
  const uploadReport = async (values) => {
    //google recaptcha
    const token = await captchaRef.current.executeAsync();
    captchaRef.current.reset();
    values.response_token = token;
    
    try {
      const { code } = await addReport(values);
      if (code === '10000') {
        message.success(t('addreport.message.success'));
        form.resetFields();
        setTextAreaValue('');
        setName('');
        setFilesArray([]);
        setOthers(false);
        navigate('/user?page=my_report');
      } else {
        message.error(t('addreport.message.failed'));
      }
    } catch (error) {
      // console.log(error);
    }
  };

  // 错误处理
  const handleFinshFailed = (e) => {
    message.error(t('addreport.message.validate_filed'));
    // console.log('failed', e);
  };

  // 厂商名字
  const onNameChange = (event) => {
    setName(event.target.value);
  };

  // 离开聚焦事件
  const handleCompanyBlur = () => {
    if (!name) {
      return message.error('required company name');
    }
  };

  // 文件提交处理
  const onFilesUploaded = (filesList) => {
    let files = filesList
      .filter((_file) => _file.response && _file.response.data)
      .map((item) => item.response.data.file_id);
    setFilesArray(files);
  };

  const detailValidator = (rule, value) => {
    if (!TextAreaValue) {
      return Promise.reject(t('addreport.message.validate_content'))
    }
    return Promise.resolve()
  }

  const solutionValidator = (rule, value, callback) => {
    if (!TextAreaValue2) {
      callback(t('addreport.message.validate_Solutions'))
    }
    callback()
  }

  function filter(inputValue, path) {
    return path.some(option => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
  }

  function pointsOnChange(value){
      form.setFieldsValue({self_points:value})

  }

  function levelOnChange(value){
    if(value[0]===1){
      setMinPoints(1);
      setMaxPoints(9);
      form.setFieldsValue({self_points:1})
    }else if(value[0]===2){
      setMinPoints(10);
      setMaxPoints(39);
      form.setFieldsValue({self_points:10})
    }else if(value[0]===3){
      setMinPoints(40);
      setMaxPoints(69);
      form.setFieldsValue({self_points:40})
    }else if(value[0]===4){
      setMinPoints(70);
      setMaxPoints(89);
      form.setFieldsValue({self_points:70})
    }else if(value[0]===5){
      setMinPoints(90);
      setMaxPoints(100);
      form.setFieldsValue({self_points:90})
    }
  }

  const dataSource = [
    {
      key: '1',
      severity: 'Informational',
      score: '0 - 9',
    },
    {
      key: '2',
      severity: 'Low',
      score: '10 - 39',
    },
    {
      key: '3',
      severity: 'Medium',
      score: '40 - 69',
    },
    {
      key: '4',
      severity: 'High',
      score: '70 - 89',
    },
    {
      key: '5',
      severity: 'Critical',
      score: '90 - 100',
    }
  ];
  
  const columns = [
    {
      title: 'Severity',
      dataIndex: 'severity',
      key: 'severity',
    },
    {
      title: 'Score',
      dataIndex: 'score',
      key: 'score',
    }
  ];
  
  return (
    <PageContent>
      <Form
        form={form}
        labelAlign="left"
        requiredMark={false}
        initialValues={{
          company_name:_project
        }}
        onFinish={handleFormFinsh}
        onFinishFailed={handleFinshFailed}
        labelCol={{
          sm: {span: 7},
          md: {span: 5},
          lg: {span: 4},
          xl: {span: 3},
          xxl: {span: 3},
        }}
      >
        <Form.Item
          label={t('addreport.company')}
          name={'company_name'}
          rules={[
            {
              required: true,
              message: t('addreport.message.validate_company'),
            },
          ]}
        >
          <AutoComplete
            allowClear={true}
            placeholder={t('addreport.company_')}
            className={'add-report-select'}
            onSelect={handleChange}
            // onPopupScroll={handlePopupScroll}
            filterOption={(inputValue, option) =>
              option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
            style={{
              width: '50%',
              height: '50px',
              borderRadius: '6px',
            }}
          >
            {optionData.map((item) => (
              <Option 
              key={item.id}
              defaultValue={item.name}
              value={item.name}
              >
                {item.name}
              </Option>
            ))}
          </AutoComplete>
        </Form.Item>
        {
          !others && (
              <Form.Item colon={false} label=' '>
                <div>
                  <Form.Item
                      noStyle
                      name={'company_confirm'}
                      rules={[
                        (({getFieldValue}) => ({
                          required: true,
                          validator(rule, value) {
                            if (!value) {
                              return Promise.reject('Required')
                            }
                            if (getFieldValue('company_name') === value) {
                              return Promise.resolve()
                            }
                            return Promise.reject('Project name not match')
                          }
                        }))
                      ]}>
                    <Input className='custom-antd-input' style={{
                      width: '50%',
                      height: '50px',
                      borderRadius: '6px',
                    }} placeholder='Please manually type the project name to continue…' />
                  </Form.Item>
                  <CustomTooltip arrowPointAtCenter={true} placement="right" title={
                    'BugRap asks that you confirm the name of the project to ensure you are submitting bugs to the correct program. This is important so that sensitive information only gets shared with the intended audience.'
                  } style={{
                    whiteSpace:'nowrap',
                    width:'100%'
                  }}>
                    <CustomQuestionCircleOutlined style={{
                      marginLeft:'10px'
                    }} />
                  </CustomTooltip>
                </div>
              </Form.Item>
          )
        }
        {others ? (
          <Form.Item
            label={' '}
            colon={false}
            name={'company_confirm'}
            rules={[
              {
                required: true,
                message: 'Please enter company name',
              },
            ]}
          >
            <Input
              style={{
                display: 'block',
                width: '50%',
              }}
              placeholder="Please enter a custom company name"
              className={'custom-antd-input'}
              value={name}
              onChange={onNameChange}
              onBlur={handleCompanyBlur}
              // onFocus={handleCompanyFocus}
            />
          </Form.Item>
        ) : null}
        <Form.Item
          label={t('addreport.Severity/Points')}
          rules={[{ required: true, message: '' }]}
        >
          <div
            style={{
              width: '100%',
              // maxWidth: '470px',
            }}
          >
            <Form.Item
              name={'level_id'}
              noStyle
              rules={[
                {
                  required: true,
                  message: t('addreport.message.validate_level'),
                },
              ]}
            >
              <Cascader
                placeholder={t('addreport.Severity')}
                className={'add-report-select'}
                popupClassName={'add-report-popup'}
                style={{
                  width: 'calc(25% - 5px)',
                  marginRight: '10px',
                }}
                fieldNames={{
                  label: 'name',
                  value: 'id',
                  children: 'children',
                }}
                options={levels}
                onChange={levelOnChange}
              />
            </Form.Item>
            <Form.Item
              noStyle
              name={'self_points'}
              rules={[
                {
                  required: true,
                  message: t('addreport.message.validate_points'),
                },
              ]}
            >
                <CustomInputNumber style={{
                  width: 'calc(25% - 5px)',
                }} min={minPoints} max={maxPoints} onChange={pointsOnChange} placeholder='Score' />
            </Form.Item>
            <CustomTooltip arrowPointAtCenter={true} placement="right" title={<span>
              <a href="https://nvd.nist.gov/vuln-metrics/cvss/v3-calculator" target="_blank" rel="noreferrer" style={{color:"#6ee6c6",textDecoration:'underline'}}>CVSS Calculator Score</a> * 10
              <br />
              <CustomTable size="small" pagination={false} dataSource={dataSource} columns={columns} style={{
                marginTop:'5px',
              }} 
              />
            </span>} style={{
              whiteSpace:'nowrap',
              width:'100%'
            }}>
              <CustomQuestionCircleOutlined style={{
                marginLeft:'10px'
              }} />
            </CustomTooltip>
          </div>
        </Form.Item>
        <Form.Item
          label={t('addreport.Weakness')}
          rules={[{ required: true, message: '' }]}
        >
          <div
            style={{
              width: '100%',
            }}
          >
            <Form.Item
              noStyle
              name={'category_ids'}
              rules={[
                {
                  required: true,
                  message: t('addreport.message.validate_category'),
                },
              ]}
            >
              <Cascader
                placeholder={t('addreport.Category')}
                className={'add-report-select'}
                fieldNames={{
                  label: 'name',
                  value: 'id',
                  children: 'children',
                }}
                options={cascaderOptions}
                showSearch={{filter,matchInputWidth:true}}
              />
            </Form.Item>
          </div>
        </Form.Item>
        {/* <Form.Item
          label={t('addreport.self_points')}
          name={'self_points'}
          rules={[
            { required: true, message: t('addreport.message.validate_points') },
          ]}
        >
          <InputNumber
            placeholder={t('addreport.self_points_')}
            style={{
              width: '100%',
              maxWidth: '470px',
            }}
            className={'custom-antd-input'}
            min={1}
            max={20}
          />
        </Form.Item> */}
        {/* <Form.Item
          label={t('addreport.Anonymous')}
          name={'is_anonymity'}
          valuePropName="checked"
        >
          <Checkbox>
            {t('addreport.Anonymous submission')}
            <span
              style={{
                color: '#4B555E',
              }}
            >
              （{t('addreport.Anonymous_checked')}）
            </span>
          </Checkbox>
        </Form.Item> */}
        <Form.Item
          label={t('addreport.Report Title')}
          name={'title'}
          rules={[
            { required: true, message: t('addreport.message.validate_title') },
          ]}
        >
          <Input
            allowClear={true}
            style={{
              width: '100%',
              // maxWidth: '470px',
            }}
            className={'custom-antd-input'}
            placeholder={t('addreport.enter_report')}
          />
        </Form.Item>
        <Form.Item
          label={t('addreport.Report Description')}
          name={'description'}
          className='description-addreport-input'
          rules={[
            {
              required: true,
              message: t('addreport.message.validate_description'),
            },
          ]}
        >
          <Input.TextArea
            allowClear={true}
            autoSize={{ minRows: 2 }}
            placeholder={t('addreport.description_tips')}
          />
        </Form.Item>
        <Form.Item label={t('addreport.Report content')}>
          <Tabs
            onChange={TabsChange}
            type="card"
            tabPosition={'bottom'}
            tabBarGutter={0}
            tabBarStyle={{
              marginTop: 0,
            }}
          >
            <TabPane
              tab="Write"
              key="1"
              style={{
                flex: 1,
                width: '100%',
              }}
            >
              <Form.Item
                name={'detail'}
                noStyle
                rules={[
                  {
                    required: true,
                    validator: detailValidator
                  },
                ]}
              >
                <div>
                  <MarkdownEditor
                      mode={1}
                      value={TextAreaValue}
                      height={500}
                      onChange={({text, html}) => setTextAreaValue(text)} />
                </div>
              </Form.Item>
            </TabPane>
            <TabPane tab="Preview" key="2">
              <MarkdownEditor
                  mode={2}
                  value={TextAreaValue}
                  height={500} />
            </TabPane>
          </Tabs>
        </Form.Item>
        <Form.Item
          label={t('addreport.Solutions')}
          rules={[
            {
              required: true,
              validator: solutionValidator,
            },
          ]}
        >
          <Tabs
            onChange={TabsChange}
            type="card"
            tabPosition={'bottom'}
            tabBarGutter={0}
            tabBarStyle={{
              marginTop: 0,
            }}
            style={{
              color:'#fff'
            }}
          >
            <TabPane
              tab="Write"
              key="1"
              style={{
                flex: 1,
                width: '100%',
              }}
            >
              <Form.Item
                name={'solution'}
                noStyle
                rules={[
                  {
                    required: true,
                    validator: solutionValidator,
                  },
                ]}
              >
                <div>
                  <MarkdownEditor
                      mode={1}
                      value={TextAreaValue2}
                      height={300}
                      onChange={({text, html}) => setTextAreaValue2(text)} />
                </div>
              </Form.Item>
            </TabPane>
            <TabPane tab="Preview" key="2">
              <MarkdownEditor
                  mode={2}
                  value={TextAreaValue2}
                  height={300} />
            </TabPane>
          </Tabs>
        </Form.Item>
        <Form.Item
          wrapperCol={{
            xs: {
              offset: 0,
            },
            sm: {
              offset: 7,
            },
            md: {
              offset: 5,
            },
            lg: {
              offset: 4,
            },
            xl: {
              offset: 3,
            },
            xxl: {
              offset: 3,
            },
          }}
        >
          <p
            style={{
              fonSize: '12px',
              color: '#4B555E',
            }}
          >
            You can upload more files as attachments, such as: PDF (max 10MB per file), MP4 (max 300M per file)
          </p>
          <FilesUpload onFilesUploaded={onFilesUploaded} />
        </Form.Item>
        <Form.Item
          wrapperCol={{
            xs: {
              offset: 0,
            },
            sm: {
              offset: 7,
            },
            md: {
              offset: 5,
            },
            lg: {
              offset: 4,
            },
            xl: {
              offset: 3,
            },
            xxl: {
              offset: 3,
            },
          }}
        >
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_SITE_KEY}
            ref={captchaRef}
            size={'invisible'}
            theme={'dark'}
            />
          <Button
            type="primary"
            htmlType="submit"
            style={{
              height: '42px',
              backgroundColor: '#18EAC4',
              color: '#0e0e0e',
              border: 'none',
            }}
          >
            {t('addreport.submit')}
          </Button>
        </Form.Item>
      </Form>
    </PageContent>
  );
};

export default AddReport;
